export function filterLinks({ links, user }) {
  return links.filter(link => {
    switch (link.name) {
      case 'payouts': {
        return user.paymentsEnabled;
      }
      default:
        return true;
    }
  });
}
